import { useEffect, useMemo, useState } from 'react';
import { OrderDetailStatus } from '@modules/orders/types';
import dayjs from 'dayjs';

export const useCronometreOrder = (order: any, maxTime: number = 300) => {
  const [elapsedTime, setElapsedTime] = useState(0);

  const preparationTime = maxTime; // 5 minutos de tiempo de preparación

  useEffect(() => {
    if (order?.createdAt) {
      const createdAt = dayjs(order.createdAt);
      const now = dayjs();
      const initialElapsedTime = now.diff(createdAt, 'second');
      setElapsedTime(initialElapsedTime);
    }
  }, [order?.createdAt]);
  const getColor = () => {
    if (order?.status === OrderDetailStatus.created) {
      return 'bg-blue-500 border-blue-700';
    }
    if (elapsedTime >= preparationTime) {
      return 'bg-red-500 border-red-700';
    }
    if (elapsedTime >= preparationTime * 0.75) {
      return 'bg-yellow-500 border-yellow-700';
    }
    return 'bg-green-500 border-green-700';
  };
  useEffect(() => {
    let timer: any;
    if (order?.status !== 'done') {
      timer = setInterval(() => {
        setElapsedTime((prevTime) => prevTime + 1);
      }, 1000);
    }

    return () => {
      if (timer) {
        clearInterval(timer);
      }
    };
  }, [order?.status]);
  const formatElapsedTime = (tt: number) => {
    const seconds = tt % 60;
    const minutes = Math.floor((tt % 3600) / 60);
    const hours = Math.floor((tt % 86400) / 3600);
    const days = Math.floor((tt % 2592000) / 86400); // 2592000 = 30 * 86400 (30 días en segundos)
    const months = Math.floor(tt / 2592000); // 30 días es un mes

    const formattedSeconds = seconds.toString().padStart(2, '0');
    const formattedMinutes = minutes.toString().padStart(2, '0');
    const formattedHours = hours.toString().padStart(2, '0');

    if (months > 0) {
      return `${months}M${days}d`;
    }
    if (days > 0) {
      return `${days}d${formattedHours}h`;
    }
    if (hours > 0) {
      return `${formattedHours}h${formattedMinutes}m`;
    }
    return `${formattedMinutes}:${formattedSeconds}`;
  };
  return {
    elapsedTime,
    formatElapsedTime,
    preparationTime,
    getColor,
  };
};
